import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../../context/CartContext';

export default function CartIcon({ className = '' }) {
  const navigate = useNavigate();
  const { totals } = useCart();
  const count = totals.itemCount;

  return (
    <button
      onClick={() => navigate('/cart')}
      data-testid="cart-icon-btn"
      className={`relative p-2 rounded-lg text-slate-300 hover:text-white hover:bg-slate-800 transition ${className}`}
      aria-label={`Cart (${count} items)`}
    >
      <ShoppingCart className="w-5 h-5" />
      {count > 0 && (
        <span
          data-testid="cart-badge-count"
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-blue-500 text-white text-[10px] font-bold flex items-center justify-center"
        >
          {count > 99 ? '99+' : count}
        </span>
      )}
    </button>
  );
}
